import { SURF_PLUGIN_ID } from "../model/surfDeck.js";
import { surfGraphQLFetch } from "../graphql/httpClient.js";
import { SURF_GRAPHQL } from "../graphql/queries.js";
import { COLD_SYNC_SINCE } from "../sync/types.js";
import { newId } from "../model/surfDeck.js";
import { cloneSurfStyle } from "./surfStyle.js";
export const SURF_STYLE_TEMPLATE_DOC_TYPE = "surf.style.template";
export const SURF_STYLE_TEMPLATE_SCHEMA_VERSION = 1;
export function styleTemplateToPayloadJSON(style, presetId) {
    const payload = {
        schemaVersion: SURF_STYLE_TEMPLATE_SCHEMA_VERSION,
        presetId,
        style: cloneSurfStyle(style),
    };
    return JSON.stringify(payload);
}
export function parseStyleTemplatePayload(raw) {
    try {
        const obj = JSON.parse(raw);
        if (!obj?.style?.palette || !obj.style.textRoles)
            return null;
        return obj;
    }
    catch {
        return null;
    }
}
function rowToTemplate(row) {
    if (row.docType !== SURF_STYLE_TEMPLATE_DOC_TYPE || row.pluginId !== SURF_PLUGIN_ID)
        return null;
    if (row.deleted)
        return null;
    const payload = parseStyleTemplatePayload(row.payloadJSON);
    if (!payload)
        return null;
    return {
        documentId: row.documentId,
        title: row.title,
        style: payload.style,
        presetId: payload.presetId,
        version: row.version ?? undefined,
        updatedAt: row.updatedAt,
    };
}
export async function listSurfStyleTemplates(cfg) {
    const idToken = await cfg.getIdToken();
    const results = [];
    let nextToken;
    let pages = 0;
    do {
        pages += 1;
        const page = await surfGraphQLFetch({
            endpoint: cfg.endpoint,
            idToken,
            query: SURF_GRAPHQL.deltaSync,
            variables: {
                input: {
                    lastSyncAt: COLD_SYNC_SINCE,
                    nextToken,
                },
            },
            resultKey: "deltaSync",
        });
        for (const row of page.pluginDocuments ?? []) {
            const rec = rowToTemplate(row);
            if (rec)
                results.push(rec);
        }
        nextToken = page.nextToken ?? undefined;
    } while (nextToken && pages < 8);
    return results.sort((a, b) => (b.updatedAt ?? "").localeCompare(a.updatedAt ?? ""));
}
export async function saveSurfStyleTemplate(cfg, title, style, presetId, documentId, expectedVersion) {
    const idToken = await cfg.getIdToken();
    const payloadJSON = styleTemplateToPayloadJSON(style, presetId);
    const trimmedTitle = title.trim() || "Template stile";
    if (documentId) {
        const row = await surfGraphQLFetch({
            endpoint: cfg.endpoint,
            idToken,
            query: SURF_GRAPHQL.updatePluginDocument,
            variables: {
                documentId,
                input: {
                    title: trimmedTitle,
                    state: "active",
                    docSchemaVersion: SURF_STYLE_TEMPLATE_SCHEMA_VERSION,
                    payloadJSON,
                    expectedVersion: expectedVersion ?? undefined,
                },
            },
            resultKey: "updatePluginDocument",
        });
        const rec = rowToTemplate(row);
        if (!rec)
            throw new Error("Risposta update template non valida.");
        return rec;
    }
    const id = newId();
    const row = await surfGraphQLFetch({
        endpoint: cfg.endpoint,
        idToken,
        query: SURF_GRAPHQL.putPluginDocument,
        variables: {
            input: {
                documentId: id,
                pluginId: SURF_PLUGIN_ID,
                docType: SURF_STYLE_TEMPLATE_DOC_TYPE,
                docSchemaVersion: SURF_STYLE_TEMPLATE_SCHEMA_VERSION,
                title: trimmedTitle,
                state: "active",
                payloadJSON,
            },
        },
        resultKey: "putPluginDocument",
    });
    const rec = rowToTemplate(row);
    if (!rec)
        throw new Error("Risposta put template non valida.");
    return rec;
}
export async function deleteSurfStyleTemplate(cfg, documentId) {
    const idToken = await cfg.getIdToken();
    await surfGraphQLFetch({
        endpoint: cfg.endpoint,
        idToken,
        query: SURF_GRAPHQL.deletePluginDocument,
        variables: { documentId },
        resultKey: "deletePluginDocument",
    });
}
export async function renameSurfStyleTemplate(cfg, record, title) {
    return saveSurfStyleTemplate(cfg, title, record.style, record.presetId, record.documentId, record.version);
}
